const getDefaultState = () => {
  return {
    lists: [],
    properties: [],

    selectedProperty: {},

    /** Whether viewing recently deleted (trash) */
    recentlyDeletedActive: false,
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_TO_LIST(state, property) {
    state.lists.push(property);
  },
  REPLACE_IN_LIST(state, replaceObject) {
    const index = state.lists.findIndex((list) => list._id === replaceObject.oldID);
    state.lists.splice(index, 1, replaceObject.newData);
  }
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  /** LISTS */
  addToList({ commit }, property) {
    commit("ADD_TO_LIST", property);
  },
  replaceInList({commit}, replaceObject) {
    commit("REPLACE_IN_LIST", replaceObject);
  }
};

const properties = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default properties;
